module.exports = __webpack_public_path__ + "img/ES1544.950d77e7.png";